import React from 'react';
import { FormattedMessage } from 'react-intl';
import { string, array } from 'prop-types';
import Card from '../Card/Card';
import OfferStatsTable from './OfferStatsTable';

const propTypes = {
  statistics: array.isRequired,
  currency: string,
};

const defaultProps = {
  statistics: [],
};

const OfferLandingsList = ({ statistics, currency, collapsing }) => (
  <div className="offer-card">
    <Card>
      <p className="offer-stats-title">
        <FormattedMessage id="offer.conversions.title" defaultMessage="Conversions" />
      </p>
      <OfferStatsTable statistics={statistics} currency={currency} />
    </Card>
  </div>
);

OfferLandingsList.propTypes = propTypes;
OfferLandingsList.defaultProps = defaultProps;

export default OfferLandingsList;
